<template>
	<div class="artwork-review" :class="{ 'my-review': isMyReview }">
		<div class="artwork-review-title">
			<strong>{{ review.author_name }}</strong>

			<div class="artwork-review-badges">
				<!-- <span v-if="isMyReview" class="badge text-bg-success rounded-pill ms-2">My Review</span> -->
				<span v-if="isShortlist" class="badge text-bg-primary rounded-pill ms-2">
					<span class="fas fa-heart me-2"></span>Short List
				</span>
				<span v-if="isFinalist" class="badge text-bg-light rounded-pill border border-dark ms-2">
					<span class="fas fa-trophy me-2"></span>Nominated
				</span>
			</div>
		</div>
		<p class="artwork-review-comment" v-if="review.comment">{{ review.comment }}</p>
	</div>
</template>

<script>
export default {
	props: {
		review: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			pendingSave: false,
		}
	},

	computed: {
		isShortlist() {
			return this.review.shortlist == 'Yes';
		},
		isFinalist() {
			return this.review.finalist == 'Yes';
		},
		isMyReview() {
			return this.review.author == this.$store.getters.getUserId;
		}
	}
}
</script>

<!--  -->